import {Component, OnInit} from '@angular/core';

@Component({
	selector: 'k-table-header',
	templateUrl: './table-header.component.html',
	styleUrls: ['./table-header.component.scss']
})
export class TableHeaderComponent implements OnInit {

	constructor() {
	}

	ngOnInit(): void {
	}

}
